import { useState } from 'react';
import Catalog from './catalog';
import { ViewMode } from './catalog-wrapper';
import { useSearchParams } from 'react-router-dom';

function NewItkSearch() {
    const [params] = useSearchParams();
    const [viewMode, setViewMode] = useState(ViewMode.List);
    return <Catalog key={params.get('q')} viewMode={viewMode} setViewMode={setViewMode} globalMode />;
}

export default NewItkSearch;
